import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';

const { createUniqueId } = common;
const domId = createUniqueId();
let componentProps = null;

const renderOpenedRedBag = (props) => {
    const component = OpenedRedBag({ ...componentProps, ...props });
    dom.$id(domId).outerHTML = component;
};

const OpenedRedBag = (props = {}) => {
    componentProps = props;
    const data = {
        domId,
        amount: props.amount || 0,
    };
    const { clickToUseCb } = props;
    const events = {
        gotoTopPoi: () => {
            clickToUseCb && clickToUseCb();
            return false;
        },
    };

    const component = createComponent(tpl, { data, style }, events);

    return component;
};

export default OpenedRedBag;
export { renderOpenedRedBag };
